<!--Header-->
<div class="d-flex align-items-center py-3 pl-4 pr-3" [class.bg-white]="isCxone" *ngIf="!isLoading">
    <div [ngClass]="{ 'cxone-header': isCxone }" class="font-size-32" cvLocalizedText langSection="Menu_Pages" langKey="WallboardView">Launch Wallboard</div>
    <div class="flex-grow-1"></div>

    <div class="search-box live-search" style="width:400px" *ngIf="!isLoading">
        <input type="search" class="form-control form-control-lg" [(ngModel)]="filterText" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
        <span class="clear-input" *ngIf="filterText.length > 0" (click)="filterText = ''"></span>
    </div>

    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail ml-4" *ngIf="!isCxone" (click)="navigationService.selectedPageGroup = false">
        <svg class="icon-24"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>
</div>

<!--Body-->
<div class="d-flex" [class.bg-white]="isCxone">
    <cv-loader size="large" *ngIf="isLoading"></cv-loader>

    <!--Left Side-->
    <div class="col-6 pl-4" style="height:calc(100vh - 143px); overflow-y:auto" *ngIf="!isLoading">
        <div class="ml-4" *ngIf="WallboardsFiltered?.length == 0" cvLocalizedText langSection="Wallboard_Management" langKey="No_Wallboards_Found">No Wallboards Found</div>

        <!--Wallboards List-->
        <div style="column-count:2; column-gap:1.25rem">
            <!--Most Recent-->
            <div class="d-inline-block w-100 mb-2" *ngIf="MostRecentWallboardsFiltered.length > 0">
                <div class="font-weight-bold py-1" style="border-bottom:2px solid #a8afb9" [ngClass]="{ 'cxone-sub-header': isCxone }" cvLocalizedText langSection="Wallboard_Management" langKey="Most_Recent">Most Recent</div>

                <div class="hoverContainer babySharkHover d-flex align-items-center cursor-pointer py-2 px-3" [ngClass]="{ 'bg-babyShark': selectedWallboard?.WallboardID == wallboard.WallboardID }"
                     *ngFor="let wallboard of MostRecentWallboardsFiltered" (click)="selectWallboard(wallboard)">
                    <div class="text-break" [ngClass]="{ 'cxone-sub-title': isCxone }">{{wallboard.WallboardName}}</div>
                    <div class="flex-grow-1"></div>

                    <button type="button" class="icon-btn fill-no2Pencil fill-hover-panther displayHoverFlex d-none" (click)="refreshWallboard(wallboard)" *ngIf="wallboard.Slides?.length > 0 && !isRefreshing">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/refresh.svg#refresh"></use></svg>
                    </button>

                    <button type="button" class="icon-btn fill-no2Pencil fill-hover-panther displayHoverFlex d-none" (click)="launchWallboardService.openWallboardPreview(wallboard.WallboardID)">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/play.svg#play"></use></svg>
                    </button>
                </div>
            </div>

            <!--Folders-->
            <div class="d-inline-block w-100 mb-2" *ngFor="let folder of FoldersFiltered">
                <div class="font-weight-bold py-1" style="border-bottom:2px solid #a8afb9" [ngClass]="{ 'cxone-sub-header': isCxone }"  *ngIf="folder != ''">{{folder}}</div>

                <div class="hoverContainer babySharkHover d-flex align-items-center cursor-pointer py-2 px-3" [ngClass]="{ 'bg-babyShark': selectedWallboard?.WallboardID == wallboard.WallboardID }"
                     *ngFor="let wallboard of wallboardsInFolderFiltered(folder)" (click)="selectWallboard(wallboard)">
                    <div class="text-break"  [ngClass]="{ 'cxone-sub-title': isCxone }">{{wallboard.WallboardName}}</div>
                    <div class="flex-grow-1"></div>

                    <button type="button" class="icon-btn fill-no2Pencil fill-hover-panther displayHoverFlex d-none" (click)="refreshWallboard(wallboard)" *ngIf="wallboard.Slides?.length > 0 && !isRefreshing">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/refresh.svg#refresh"></use></svg>
                    </button>

                    <button type="button" class="icon-btn fill-no2Pencil fill-hover-panther displayHoverFlex d-none" (click)="launchWallboardService.openWallboardPreview(wallboard.WallboardID)">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/play.svg#play"></use></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!--Right Side-->
    <div class="col-6 pr-4" style="height:calc(100vh - 143px); overflow-y:auto" *ngIf="!isLoading">
        <div class="d-flex justify-content-center align-items-center rounded border" style="min-height:400px" *ngIf="!selectedWallboard">
            <div class="font-size-36 color-valyrianSteel" cvLocalizedText langSection="Wallboard_Management" langKey="No_Wallboard_Selected">No Wallboard Selected</div>
        </div>

        <div *ngIf="selectedWallboard">
            <div class="w-100 position-relative" style="min-height:400px">
                <launch-wallboard-preview [wallboard]="selectedWallboard" *ngIf="refreshPreview && selectedWallboard?.Slides?.length > 0"></launch-wallboard-preview>
                <img src="../Admin/ImageResizer.aspx?imgid=-51&w=279&h=157" class="w-100" style="min-height:400px; opacity:.85" alt="Wallboard Not Available" *ngIf="selectedWallboard?.Slides?.length == 0" />
            </div>

            <div class="d-flex mt-3">
                <div class="col-5">
                    <div class="d-flex font-weight-bold py-1"  [ngClass]="{ 'cxone-sub-header': isCxone }" style="border-bottom:2px solid #a8afb9" cvLocalizedText langSection="Wallboard_Management" langKey="Details">Details</div>

                    <div class="color-whaleTail p-1" cvLocalizedText langSection="Wallboard_Management" langKey="Date_Created" [ngClass]="{ 'cxone-sub-title': isCxone }">Date Created</div>
                    <div class="color-whaleTail p-1 ml-3" [ngClass]="{ 'cxone-sub-title': isCxone }">{{(selectedWallboard.CreatedDate | date:'short':'+0000').replace(",", "")}}</div>
                    <div class="color-whaleTail p-1" [ngClass]="{ 'cxone-sub-title': isCxone }" cvLocalizedText langSection="Wallboard_Management" langKey="Last_Viewed">Last Viewed</div>
                    <div class="color-whaleTail p-1 ml-3" [ngClass]="{ 'cxone-sub-title': isCxone }" *ngIf="selectedWallboard.LastViewed">{{(selectedWallboard.LastViewed | date:'short':'+0000').replace(",", "")}}</div>
                </div>

                <div class="col-7" *ngIf="selectedWallboard?.Slides?.length > 0">
                    <div class="d-flex font-weight-bold py-1" style="border-bottom:2px solid #a8afb9"  [ngClass]="{ 'cxone-sub-header': isCxone }" cvLocalizedText langSection="Wallboard_Management" langKey="Slides">Slides</div>

                    <div>
                        <div class="color-whaleTail p-1"  [ngClass]="{ 'cxone-sub-title': isCxone }" *ngFor="let slide of selectedWallboard.Slides; let i = index">{{i + 1}}. {{slide.SlideName}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
